import { Result } from "@/shared/feedback/result";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";
import { SignStatusIcon } from "@/modules/signing/shared/ui/sign-status-icon/sign-status-icon";
import { usePalette } from "@/shared/theme";
import Text from "@/shared/typography/text";

export function StatusProcessing() {
  const t = useTranslations("Common");
  const palette = usePalette();

  return (
    <Result
      status={"info"}
      title={
        <Text as={"span"} medium type={"headline1"}>
          {t("SIGN_STATUS_PROCESSING_TITLE")}
        </Text>
      }
      icon={
        <div className={"flex justify-center"}>
          <SignStatusIcon
            icon={<LoadingOutlined />}
            iconColor={palette.primary[8]}
            iconBackgroundColor={palette.primary[1]}
            iconSecondaryBackgroundColor={palette.primary[0]}
          />
        </div>
      }
    />
  );
}
